import React, { useRef, useContext, useCallback } from "react"
import AuthContext from "../admin/AuthContext"
import { useUnmounted, useIntersection, useSubscriptionProvider } from "../lib"

const Entity = props => {
    const { info, entity, visibility, noadmin } = props
    const domRef = useRef()
    const unmounted = useUnmounted()
    const visible = useRef()
    const { user } = useContext(AuthContext)
    const setFieldAdmin = useSubscriptionProvider("fieldAdmin")
    const newInfo = { entity, user, language: info ? info.language : undefined }
    //console.log(props, data, user)

    const parents = useRef()
    const lineageId = useRef()
    const setupLineage = () => {
        parents.current = [
            ...(info && info.parents && info.parents.current ? info.parents.current : []),
            { domRef: domRef, ...props },
        ]
        lineageId.current = ""
        parents.current.forEach(item => {
            const { entity, field } = item
            lineageId.current += `${entity ? entity._id.$oid : 0} - ${field}`
        })
    }
    const mouseOver = useRef(false)
    const onMouseOver = useCallback(() => {
        if (noadmin || !user) return
        if (mouseOver.current) return
        //console.log("mouse over", parents.current)
        mouseOver.current = true
        setFieldAdmin({ mouse: "enter", fieldLine: parents.current })
    }, [user, noadmin, setFieldAdmin])

    const onMouseLeave = useCallback(() => {
        if (noadmin || !user) return
        //console.log("mouse leave", parents.current)
        mouseOver.current = false
        setFieldAdmin({ mouse: "leave", fieldLine: parents.current })
    }, [user, noadmin, setFieldAdmin])

    const onIntersect = useCallback(
        entry => {
            if (unmounted.current || visible.current || !entry.isIntersecting) return
            visible.current = true
            domRef.current.classList.add("visible")
        },
        [unmounted, visible, domRef]
    )
    useIntersection(visibility ? domRef : null, onIntersect)

    if (!entity) return null
    const wrapperProps = {}
    if (user) {
        /* && !parents.current)*/
        setupLineage()
        newInfo.parents = parents
        wrapperProps.onMouseOver = onMouseOver
        wrapperProps.onMouseLeave = onMouseLeave
    }
    const bundleClass = entity.type === "node" ? `bundle-${entity.bundle}` : ""
    const classes = `entity entity-type-${entity.type} ${bundleClass} ${props.className || ""}`

    const Tag = props.tag || "div"

    return (
        <Tag ref={domRef} className={classes} {...wrapperProps}>
            {props.children(newInfo)}
        </Tag>
    )
}
export default Entity
